import { useEffect, useState } from 'react';
import CargoPrioritizationHeader from './components/CargoPrioritizationHeader';
import { SCUIContent } from '../../atomic/organisms';
import { Grid, Paper, Table, TableContainer, Box } from '@mui/material';
import { CargoPrioritizationBody } from './components/CargoPrioritizationBody';
import { CargoPrioritizationQuery } from '../../services/query';
import { SCUIButton, SCUILoadingLinear } from '../../atomic/atoms';
import { t } from 'i18next';
import { CargoPrioritizationCommand } from '../../services/command';
import Swal from 'sweetalert2';
import { SCUIBreadCrumb } from '../../atomic/molecules';
import SCUIDownloadButton from '../../atomic/atoms/SCUIDownloadButton/SCUIDownloadButton';
import TimeHelper from '../../utils/time';
import { CPP, cppCls } from './cargoPrioritization.classes';

export default function CargoPrioritization() {
    const [dirty, setDirty] = useState(false);
    const [loading, setLoading] = useState(false);
    const [excelData, setExcelData] = useState<any>();
    const [getShippingCompanyRedirectManagement, setGetShippingCompanyRedirectManagement] = useState<any>([]);
    const [dataState, setDataState] = useState<any>(getShippingCompanyRedirectManagement);

    const handleChangePriorty = (event: any, index: number, datas: any) => {
        const value = event.target.value;
        const trimmedValue = value.replace(/^0+(?=\d)/, '');
        const newDatas = { ...datas };
        newDatas.shippingCompanyRedirects[index].priority = Number(trimmedValue);
        newDatas.shippingCompanyRedirects[index].operatorId = -1;
        setDirty(true);
        setDataState(newDatas);
    };

    const handleChangeOrderLimit = (event: any, index: number, datas: any) => {
        const newDatas = { ...datas };
        const inputValue = event.target.value;
        const numericValue = inputValue.replace(/\./g, '');
        const parsedValue = isNaN(Number(numericValue)) ? 0 : Number(numericValue);
        newDatas.shippingCompanyRedirects[index].orderLimits = Number(parsedValue);
        newDatas.shippingCompanyRedirects[index].operatorId = -1;
        setDirty(true);
        setDataState(newDatas);
    };

    const handleSwitchChangeRedirectIsActive = (event: any, index: number, datas: any) => {
        const newDatas = { ...datas };
        newDatas.shippingCompanyRedirects[index].redirectIsActive = event.target.checked;
        newDatas.shippingCompanyRedirects[index].operatorId = -1;
        setDirty(true);
        setDataState(newDatas);
    };

    const handleSwitchChangeCodRedirectIsActive = (event: any, index: number, datas: any) => {
        const newDatas = { ...datas };
        newDatas.shippingCompanyRedirects[index].codRedirectIsActive = event.target.checked;
        newDatas.shippingCompanyRedirects[index].operatorId = -1;
        setDirty(true);
        setDataState(newDatas);
    };

    const GetShippingCompanyRedirect = () => {
        CargoPrioritizationQuery.GetShippingCompanyRedirectManagement()
            .then((res: any) => {
                if (res) {
                    setGetShippingCompanyRedirectManagement(res.data);
                }
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            });
    };

    const UpdateShippingCompanyRedirect = async () => {
        setLoading(true);
        const updatedRedirects = dataState?.shippingCompanyRedirects?.map((redirect: any) => {
            const rest = { ...redirect };
            delete rest.userName;
            return rest;
        });
        setDataState({ ...dataState, shippingCompanyRedirects: updatedRedirects });
        let params = {
            shippingCompanyRedirects: updatedRedirects,
        };
        Swal.fire({
            text: t('general.sureText'),
            cancelButtonText: t('general.cancel'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t('general.save'),
        }).then((result: any) => {
            if (result.isConfirmed) {
                if (updatedRedirects) {
                    CargoPrioritizationCommand.UpdateShippingCompanyRedirectManagement(params)
                        .then(() => {
                            Swal.fire(t('general.updated'), ' ', 'success');
                        })
                        .catch((error: any) => {
                            console.log('Hata :>> ', error);
                        })
                        .finally(() => {
                            setLoading(false);
                            GetShippingCompanyRedirect();
                        });
                }
            }
            setLoading(false);
        });
    };

    const buildExcelData = (data: any) => {
        if (data?.length === 0) return [];
        let tempTotalOrderCount = 0;

        const returnExcelData = data.shippingCompanyRedirects?.map((item: any) => {
            const matchingData = data.priorityOrders?.find(
                (priority: any) => priority.shippingCompanyId === item.shippingCompanyId
            );
            tempTotalOrderCount = tempTotalOrderCount + (matchingData ? matchingData.orderQuantity : 0);
            return {
                shippingCompanyId: item.shippingCompanyId,
                shippingCompanyName: item.shippingCompanyName,
                priority: item.priority,
                orderLimits: item.orderLimits,
                redirectIsActive: item.redirectIsActive ? 'Aktif' : 'Pasif',
                codRedirectIsActive: item.codRedirectIsActive ? 'Aktif' : 'Pasif',
                orderQuantity: matchingData ? matchingData.orderQuantity : '-',
                priorityOrderQuantity: matchingData ? matchingData.priortyOrderQuantity : '-',
                lastChangeDate: TimeHelper.formatDate(item.changeOn),
                lastChangedBy: item.userName,
            };
        });
        return returnExcelData.map((excelItem: any) => {
            return {
                shippingCompanyId: excelItem.shippingCompanyId,
                shippingCompanyName: excelItem.shippingCompanyName,
                priority: excelItem.priority,
                orderLimits: excelItem.orderLimits,
                redirectIsActive: excelItem.redirectIsActive,
                codRedirectIsActive: excelItem.codRedirectIsActive,
                orderQuantity: excelItem.orderQuantity,
                orderPercentage: isNaN(excelItem.orderQuantity)
                    ? '-'
                    : `%${((excelItem.orderQuantity / tempTotalOrderCount) * 100).toFixed(2)}`,
                priorityOrderQuantity: excelItem.priorityOrderQuantity,
                lastChangeDate: excelItem.lastChangeDate,
                lastChangedBy: excelItem.lastChangedBy,
            };
        });
    };

    useEffect(() => {
        if (getShippingCompanyRedirectManagement) setExcelData(buildExcelData(getShippingCompanyRedirectManagement));
    }, [getShippingCompanyRedirectManagement]);

    useEffect(() => {
        GetShippingCompanyRedirect();
    }, []);

    useEffect(() => {
        const handleBeforeUnload = (event: any) => {
            if (dirty) {
                event.preventDefault();
                event.returnValue = '';
            }
        };

        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [dirty]);

    return (
        <SCUIContent className={`${CPP.page} `}>
            <SCUIBreadCrumb title={t('cargoPrioritization.pageTitle')} componentLink={'CargoPrioritization'} />
            <SCUILoadingLinear display={loading} />
            <Box className={CPP.excelDownloadWrap}>
                <SCUIDownloadButton
                    position="right"
                    excelData={{
                        excelDownloadData: excelData,
                        hiddenExcelColumn: ['shippingCompanyId'],
                        excelDownloadFolderName: t('cargoPrioritization.excelTitle'),
                    }}
                />
            </Box>
            <Box className={CPP.tableSection}>
                <TableContainer component={Paper} className={CPP.tableContainer} sx={{ marginTop: '2rem' }}>
                    <Table className={CPP.table}>
                        <CargoPrioritizationHeader />
                        <CargoPrioritizationBody
                            datas={getShippingCompanyRedirectManagement}
                            handleChangeOrderLimit={handleChangeOrderLimit}
                            handleChangePriorty={handleChangePriorty}
                            handleSwitchChangeRedirectIsActive={handleSwitchChangeRedirectIsActive}
                            handleSwitchChangeCodRedirectIsActive={handleSwitchChangeCodRedirectIsActive}
                        />
                    </Table>
                </TableContainer>
            </Box>
            <Grid
                className={CPP.saveActions}
                sx={{ marginTop: '1.5rem', justifyContent: 'flex-end', display: 'flex' }}
                size={{
                    xs: 12,
                    md: 12,
                    lg: 12,
                    xl: 12,
                }}
            >
                <SCUIButton
                    text={t('general.save')}
                    type="primary"
                    sizeType="fixed"
                    size={'l'}
                    buttonType="button"
                    className={cppCls(CPP.input, CPP.inputButton, CPP.btnSave)}
                    onClick={() => {
                        UpdateShippingCompanyRedirect();
                        setDirty(false);
                    }}
                ></SCUIButton>
            </Grid>
        </SCUIContent>
    );
}
